import React, { useState } from 'react';
import c from 'classnames';
import AnimateHeight from 'react-animate-height';

import WysiwygField from '../../WysiwygField';

import '../style.scss';
import Container from '../../Container';

const ContentParsed = ({ children }) => {
  if (typeof children === 'string') {
    return (<WysiwygField html={children} />);
  }

  return (
    <div>{children}</div>
  );
};

const AccordeonTitle = ({ className, children }) => {
  return <h3 className={className}>{children}</h3>;
};

const AccordionItem = ({ title, content, iconClassName, duration, easing, titleComponent, className, hasContainer = false }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [isMouseEvent, setIsMouseEvent] = useState(false);

  window.addEventListener('keydown', () => {
    if (isMouseEvent) setIsMouseEvent(false);
  });

  window.addEventListener('mousedown', () => {
    if (!isMouseEvent) setIsMouseEvent(true);
  });

  const classes = c(className, 'Accordion__item', {
    collapsed: collapsed,
    mouse: isMouseEvent,
    keyboard: !isMouseEvent,
  });
  const iconClasses = c('icon', iconClassName);
  const AccordeonTitle = titleComponent;

  return (
    <div className={classes}>
      {hasContainer && (
        <Container>
          <AccordeonTitle className="Accordion__item__title">
            <button type="button"
              onClick={() => setCollapsed(!collapsed)}
              onFocus={() => {
                if (!isMouseEvent) setCollapsed(false);
              }}
            >
              <span className={iconClasses} />
              {title}
            </button>
          </AccordeonTitle>
        </Container>
      )}
      {!hasContainer && (
        <AccordeonTitle className="Accordion__item__title">
          <button type="button"
            onClick={() => setCollapsed(!collapsed)}
            onFocus={() => {
              if (!isMouseEvent) setCollapsed(false);
            }}
          >
            <span className={iconClasses} />
            {title}
          </button>
        </AccordeonTitle>
      )}
      <AnimateHeight
        duration={duration}
        easing={easing}
        height={collapsed ? 0 : 'auto'}
      >
        <div className="Accordion__item__content">
          <ContentParsed>{content}</ContentParsed>
        </div>
      </AnimateHeight>
    </div>
  );
};

AccordionItem.defaultProps = {
  title: 'Default title',
  content: 'Default content',
  iconClassName: 'icon--arrow-right icon--variant-1',
  duration: 333,
  easing: 'cubic-bezier(0, 0, .2, 1)',
  titleComponent: AccordeonTitle,
};

export default AccordionItem;
